module.exports = __webpack_public_path__ + "static/media/aarau.a9a2196e.png";